import { FormWrapper } from "./forms/FormWrapper";
import { ListEntry } from "./ListEntry";
import { Button } from "./generic/Button";
import { TileList } from "./generic/TileList";

export const ListList = ({ lists, onClose, selectedList, setList }) => {
  return (
    <FormWrapper>
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <h2>Verfügbare Listen</h2>

        <TileList style={{ gridTemplateColumns: "1fr" }}>
          {lists.map((list) => (
            <ListEntry
              key={list.id}
              list={list}
              selected={selectedList?.id === list.id}
              setList={setList}
              onClose={onClose}
            />
          ))}
        </TileList>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            marginTop: "2rem",
          }}
        >
          <Button onClick={onClose}>⊘ Schließen</Button>
        </div>
      </div>
    </FormWrapper>
  );
};
